module.exports = __webpack_public_path__ + "img/wheel.5df7c38f.png";